import React from 'react';

function JourneyWeatherPanel({ weather }) {
	if (!weather) return null;

	const useRegional = weather.months?.[0]?.highC != null;
	const regionLabel = weather.regionLabel || 'Trail temps (°C)';

	return (
		<div className="guided-panel">
			<h3 className="guided-panel__title">Weather by month</h3>
			<p className="guided-panel__intro">{weather.source}</p>
			<div className="guided-weather__table-wrap">
				<table className="guided-weather__table">
					<thead>
						<tr>
							<th>Month</th>
							{useRegional ? (
								<th>{regionLabel}</th>
							) : (
								<>
									<th>Namche (°C)</th>
									<th>Gorak Shep (°C)</th>
								</>
							)}
							<th>Rain</th>
							<th>Verdict</th>
						</tr>
					</thead>
					<tbody>
						{weather.months.map((m) => (
							<tr key={m.month} className={m.month === 'Oct' || m.month === 'Nov' || m.month === 'Mar' || m.month === 'Apr' ? 'guided-weather__best' : ''}>
								<td><strong>{m.month}</strong></td>
								{useRegional ? (
									<td>{m.lowC} to {m.highC}</td>
								) : (
									<>
										<td>{m.namcheLow} to {m.namcheHigh}</td>
										<td>{m.gorakShepLow} to {m.gorakShepHigh}</td>
									</>
								)}
								<td>{m.rainMm}mm</td>
								<td>{m.verdict}{m.trek ? ` — ${m.trek}` : ''}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			{weather.forecastLinks && (
				<div className="guided-weather__links">
					<strong>Live forecasts (open before trek):</strong>
					<ul>
						{weather.forecastLinks.map((l) => (
							<li key={l.url}><a href={l.url} target="_blank" rel="noopener noreferrer">{l.label} →</a></li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
}

export default JourneyWeatherPanel;
